import { TrackEventParams } from '@mitresthen/matomo-tracker-react/lib/types';
import { Box, Stack } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { useCallback } from 'react';
import { useMatomoEvent } from '../hooks/useMatomoEvent';
import { navigate } from '../hooks/useNavigate';
import { Browser } from './BrowserAddons.types';
import { BrowserLogo } from './BrowserLogo';
import { Link } from '@mui/material';

const sx: Record<string, SxProps<Theme>> = {
  root: {
    alignItems: 'center',
    backgroundColor: 'rgba(128,128,128,0.1)',
    borderRadius: 1,
    display: 'inline-flex',
    gap: 1,
    padding: 1,

    '&:hover': {
      backgroundColor: 'rgba(255,255,128,0.1)',
      cursor: 'pointer',
    },
  },
  name: ({ breakpoints }) => ({
    [breakpoints.up('md')]: {
      fontSize: '80%',
    },
  }),
};

const MATOMO_EVENT: TrackEventParams = {
  category: 'Click',
  action: 'Browser addon',
};

type Props = {
  browser: Browser;
  id: string;
  name: string;
};

export function BrowserAddonBadge(props: Props) {
  const { browser, id, name } = props;

  const href = getAddonUrl(browser, id);
  const triggerEvent = useMatomoEvent(MATOMO_EVENT);

  const handleClick = useCallback(() => {
    triggerEvent({ name });
    navigate(href);
  }, [href, name, triggerEvent]);

  return (
    <Link
      underline="none"
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={handleClick}
    >
      <Stack direction="row" gap={1} alignItems="center" sx={sx.root}>
        <BrowserLogo browser={browser} />
        <Box sx={sx.name}>{name}</Box>
      </Stack>
    </Link>
  );
}

function getAddonUrl(browser: Browser, id: string) {
  switch (browser) {
    case Browser.Firefox:
      return `https://addons.mozilla.org/en-US/firefox/addon/${id}/`;
  }
}
